import { render } from "./PngsView.vue?vue&type=template&id=66da9855"
import script from "./PngsView.vue?vue&type=script&lang=js"
export * from "./PngsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__